import { CalculateVenueCo2 } from '@/domain/impact-calculate-venue/entities/calculate-venue-co2.entity';

export type Parity = {
  men: number;
  women: number;
  other: number;
};

type DateByMonth = CalculateVenueCo2['dates']['byMonth'];

export function computeTeamParity(datesByMonth: DateByMonth): Parity {
  return Object.values(datesByMonth)
    .filter((item) => item !== undefined)
    .reduce(
      (acc, item) => {
        acc.men += item.totalMen || 0;
        acc.women += item.totalWomen || 0;
        acc.other += item.totalOther || 0;
        return acc;
      },
      { men: 0, women: 0, other: 0 },
    );
}

export function computeTotalPermanentTeamParity(ESS_3: string): Parity {
  if (ESS_3) {
    const [
      permanentTeamParityWomen,
      permanentTeamParityOther,
      permanentTeamParityMen,
    ] = ESS_3.split('#').map((item) => (item && parseInt(item)) || 0);
    return {
      men: permanentTeamParityMen,
      other: permanentTeamParityOther, // others are not yet supported in ESS_3
      women: permanentTeamParityWomen,
    };
  }
  return { men: 0, women: 0, other: 0 };
}

export function computeTotalTeamParity(
  ESS_3: string,
  totalArtisticTeamParity: Parity,
): Parity {
  const totalPermanentTeamParity = computeTotalPermanentTeamParity(ESS_3);
  return {
    women: totalPermanentTeamParity.women + totalArtisticTeamParity.women,
    other: totalPermanentTeamParity.other + totalArtisticTeamParity.other,
    men: totalPermanentTeamParity.men + totalArtisticTeamParity.men,
  };
}
